var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAddressContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29602 3.01638C3.91012 1.91519 1.36183 4.19603 2.19279 6.68894L3.45424 10.43C3.59136 10.8367 3.97267 11.1105 4.40182 11.1105H13C13.5523 11.1105 14 11.5582 14 12.1105C14 12.6628 13.5523 13.1105 13 13.1105H4.40182C3.97267 13.1105 3.59136 13.3843 3.45424 13.791L2.19281 17.5321C1.36183 20.025 3.91012 22.3058 6.29603 21.2047L20.0983 14.8344C22.422 13.7619 22.422 10.4592 20.0983 9.38667L6.29602 3.01638Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAddressContactIcon);
export default __webpack_public_path__ + "static/media/EmailAddressContactIcon.bab4866fd6ad9104780cc6812f30fa63.svg";
export { ForwardRef as ReactComponent };